<div class="home-image" style="background-image: url(../assets/gpp-booth-2019.jpg)">
	<h1>Posters</h1>
</div>
<div class="wrapper">
	<div class="breadcrumbs">
    <ul>
      <li><a [routerLink]="" (click)="gotoPress()">Press</a></li>
	  <li><a [routerLink]="" id="current" (click)="gotoPoster()">Posters</a></li>	
      <li><a [routerLink]="" (click)="gotoTerms()">Image &amp; Logo Use Guidelines</a></li>
    </ul>
  </div><!-- end breadcrumbs -->
  <h1>Great Plant Picks Posters</h1>
	<div class="text-wrap">
		<p>Posters are free, but we request reimbursement for packaging at $.50 each for folded posters which are sent in a large envelope. Additionally, a shipping charge will be added prior to checkout via PayPal. A PayPal account is not required, and you can check out using a debit card, Visa, Mastercard or Amex. Folded posters can be ordered online for shipping within the U.S. only. If you are outside the U.S. and would like to order a poster, please email <a href="mailto:rickp@millergarden.org">rickp@millergarden.org</a>.</p>

<p>For one or more free rolled posters, shipped in a cardboard tube box, please email <a href="mailto:rickp@millergarden.org">rickp@millergarden.org</a> to submit your request and Rick will let you know the reimbursement amount for shipping and packaging to your location, based on the number of posters ordered.</p>

<p>Please allow 4 to 6 weeks for delivery.</p>
		</div>
	<div class="flex-grid">
	<div class="flex-col">
        <img class="size-full" src="../assets/posters/2026-gpp-poster.jpg" alt="2026 Great Plant Picks Poster">
		  <h3>2026</h3>
			<form class="add-to-cart" #form26 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="KA2KWN29DQZWQ">
<input type="image" (click)="form26.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
	
		<div class="flex-col">
        <img class="size-full" src="../assets/posters/2025-gpp-poster.jpg" alt="2025 Great Plant Picks Poster">
		  <h3>2025</h3>
			<form class="add-to-cart" #form25 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="Q5FXEXH2Y3JXQ">
<input type="image" (click)="form25.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		<div class="flex-col">
        <img class="size-full" src="../assets/posters/2024-gpp-poster.jpg" alt="2024 Great Plant Picks Poster">
		  <h3>2024</h3>
			<form class="add-to-cart" #form24 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="J3VSBZP4WYU72">
<input type="image" (click)="form24.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		<div class="flex-col">
        <img class="size-full" src="../assets/posters/2023-gpp-poster.jpg" alt="2023 Great Plant Picks Poster">
		  <h3>2023</h3>
			<form class="add-to-cart" #form23 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="XGNJPAS3PSM2Y">
<input type="image" (click)="form23.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		<div class="flex-col">
        <img class="size-full" src="../assets/posters/2022-gpp-poster.jpg" alt="2022 Great Plant Picks Poster">
		  <h3>2022</h3>
			<form class="add-to-cart" #form22 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="YBEYU3RLJ5WPG">
<input type="image" (click)="form22.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		<div class="flex-col">
        <img class="size-full" src="../assets/posters/2021-gpp-poster.jpg" alt="2021 Great Plant Picks Poster">
		  <h3>2021</h3>
			<form class="add-to-cart" #form21 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="EXSX3XY5BPETG">
<input type="image" (click)="form21.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		 <div class="flex-col">
        <img class="size-full" src="../assets/posters/2020-gpp-poster.jpg" alt="2020 Great Plant Picks Poster">
		  <h3>2020</h3>
			  <form class="add-to-cart" #form20 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="VDFQUWXQG8ZLS">
<input type="image" (click)="form20.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>


      </div>	
		 <div class="flex-col">
        <img class="size-full" src="../assets/posters/2019-gpp-poster.jpg" alt="2019 Great Plant Picks Poster">
		  <h3>2019</h3>
			  <form class="add-to-cart" #form19 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="VPHP6GRXLP5N6">
<input type="image" (click)="form19.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		 <div class="flex-col">
        <img class="size-full" src="../assets/posters/2018-gpp-poster.jpg" alt="2018 Great Plant Picks Poster">
		  <h3>2018 - SOLD OUT</h3>
			  

      </div>	
		 <div class="flex-col">
        <img class="size-full" src="../assets/posters/2017-gpp-poster.jpg" alt="2017 Great Plant Picks Poster">
		  <h3>2017</h3>
			  <form class="add-to-cart" #form17 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="TXBEZKWLRZ3NS">
<input type="image" (click)="form17.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		 <div class="flex-col">
        <img class="size-full" src="../assets/posters/2016-gpp-poster.jpg" alt="2016 Great Plant Picks Poster">
		  <h3>2016</h3>
			 <form class="add-to-cart" #form16 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="YSRDJKDXENPH2">
<input type="image" (click)="form16.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		 <div class="flex-col">
        <img class="size-full" src="../assets/posters/2015-gpp-poster.jpg" alt="2015 Great Plant Picks Poster">
		  <h3>2015</h3>
			  <form class="add-to-cart" #form15 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="Z3LGRUZYG7VYJ">
<input type="image" (click)="form15.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>

      </div>	
		 <div class="flex-col">
        <img class="size-full" src="../assets/posters/2014-gpp-poster.jpg" alt="2014 Great Plant Picks Poster">
		  <h3>2014</h3>
			<form class="add-to-cart" #form14 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="DPZHXR9N4WJJL">
<input type="image" (click)="form14.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>
      </div>
      <div class="flex-col">
        <img class="size-full" src="../assets/posters/2013-gpp-poster.jpg" alt="2013 Great Plant Picks Poster">
		  <h3>2013</h3>
		 <form class="add-to-cart" #form13 target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="4TRRGFWUZBWPW">
<input type="image" (click)="form13.submit()" src="https://millergarden.org/assets/add-to-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>


      </div>
	</div>
		<form #form1 class="view-cart aligncenter" target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post" >
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="encrypted" value="-----BEGIN PKCS7-----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-----END PKCS7-----">
<input type="image" (click)="form1.submit()" src="https://millergarden.org/assets/view-cart.png" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>
	
</div><!-- wrapper -->
